// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"f875daf0","206":"46968a2b","334":"68af7c16","601":"0910403b","811":"08b755fa","933":"9d4652dc"}[chunkId] + ".chunk.css";
};